<div [class.show]="showToast()" style="z-index: 9999;" class="toast align-items-center text-bg-danger border-0 bottom-0 end-0 position-absolute me-2 mb-2" role="alert" aria-live="assertive" aria-atomic="true">
  <div class="d-flex">
    <div class="toast-body">
      {{ 'server_offline' | translate }}
    </div>
    <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
  </div>
</div>
